import { h } from "preact";
import { Link } from "react-router-dom";

import i18n from "../i18n.js";

export default function PostPreviewItem({ whitepaper }) {
  return (
    <Link
      class="post-preview__item link--invisible"
      to={`/whitepaper/${encodeURIComponent(whitepaper.id)}`}
    >
      <div class="post-preview__image">
        <img src={whitepaper.image} alt="" class="full-width" />
      </div>
      <div class="post-preview__content">
        {whitepaper.tags.map((tag) => (
          <span class="tag tag--default mt-16 mb-16">
            <span class="tag__content">{tag}</span>
          </span>
        ))}

        <h2 class="t-subtitle2 t-subtitle2--margin-small">
          {whitepaper.title}{" "}
        </h2>

        <p class="t-caption color-shades-grey mt-16 mb-16">
          {i18n.t("whitepaper.read", { time: whitepaper.readTime })}
        </p>
        <p class="t-body4 color-shades-charcoal">{whitepaper.excerpt} </p>
      </div>
    </Link>
  );
}
